import {get, patch} from "@shared/axios";
import {UserPreferencesDisplayModel, UserPreferencesUpdateModel} from "@shared/models/user/userPreferences";
import {useStudioAdminStudioStore} from "@apps/studioadmin/stores/studioAdminStudio.store";



export const fetchUserPreferences = async () => {
    const { apiRootUrl } = useStudioAdminStudioStore();
    return await get<UserPreferencesDisplayModel>(`${apiRootUrl}/UserPreferences`);
}


export const updateUserPreferences = async (data: UserPreferencesUpdateModel) => {
    const { apiRootUrl } = useStudioAdminStudioStore();
    const result = await patch<UserPreferencesUpdateModel>(
        `${apiRootUrl}/UserPreferences`,
        {
            BuildMaximumCropperSize: data.buildMaximumCropperSize,
            BuildImagesPerRow: data.buildImagesPerRow,
            UseDarkMode: data.useDarkMode,
        } as UserPreferencesUpdateModel,
    );
    return result;
}